import EditableInput from "@/components/ui/editable-input";
import { Calendar, Briefcase } from "lucide-react";

interface AdvancedInfoSectionProps {
  isEditing?: boolean;
}

const AdvancedInfoSection = ({
  isEditing = false
}: AdvancedInfoSectionProps) => {
  // Dati di esempio - in futuro verranno dal context o props
  const formData = {
    years_experience: "8",
    specialization: "Interior Design, Architettura d'interni"
  };

  const handleInputChange = (field: string) => (value: string) => {
    // TODO: Implementare la logica di aggiornamento
    console.log(`Updating ${field}:`, value);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-900 mb-2">
          <Briefcase className="h-5 w-5" />
          Informazioni Avanzate
        </h3>
        <p className="text-sm text-gray-600">Esperienza e specializzazioni professionali</p>
      </div>
      
      {/* Experience */}
      <EditableInput
        label="Anni di Esperienza"
        value={formData.years_experience}
        icon={Calendar}
        isEditing={isEditing}
        onChange={handleInputChange('years_experience')}
        placeholder="es. 5 anni"
      />

      {/* Specialization */}
      <EditableInput
        label="Specializzazione"
        value={formData.specialization}
        icon={Briefcase}
        isEditing={isEditing}
        onChange={handleInputChange('specialization')}
        placeholder="Specializzazione"
      />
    </div>
  );
};

export default AdvancedInfoSection; 